import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = () => ({
  queues: [],
  accounts: [],
  loading: false,
  error: null,
  meaningAnalysisData: null,
  meaningAnalysisLoading: false,
  meaningAnalysisError: null,
  meaningAnalysisWidgets: {},
  // Generic operational widgets data - widget ID'ye göre
  operationalWidgets: {},
  // Time widgets data
  timeWidgets: {}
})

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
